import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

(function () {
  const mbNewsslider = document.querySelectorAll(".news-slider");
  const newsTexts = document.querySelectorAll(".single-news .description");
  let newsSwiper = [];

  for (let i = 0; i < mbNewsslider.length; i++) {
    newsSwiper[i] = new Swiper(mbNewsslider[i], {
      modules: [Pagination, Navigation],
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 25,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    });
  }

  for (let j = 0; j < newsTexts.length; j++) {
    ellipsizeTextBox(newsTexts[j])
  }

  function ellipsizeTextBox(newsText) {
    var wordArray = newsText.innerHTML.split(' ');
    while(newsText.scrollHeight > newsText.offsetHeight) {
        wordArray.pop();
        newsText.innerHTML = wordArray.join(' ') + '...';
     }
  }

  document.addEventListener("resize", function (event) {
    for (let k = 0; k < newsTexts.length; k++) {
      console.log('in resize');
      ellipsizeTextBox(newsTexts[k])
    }
  })
})();
